import React, { useCallback } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

const TooltipV2 = (props) => {
  const { customColor, showShadow, onClose, enableBackdropClick } = props
  const useStylesToolTips = makeStyles({
    arrow: {
      color: customColor || '#0033e8',
    },
    tooltip: {
      backgroundColor: customColor || '#0033e8',
      padding: '8px 16px',
      boxShadow: showShadow ? '0 0 8px 0 rgba(0, 0, 0, 0.15)' : '',
    },
    popper: {
      pointerEvents: 'auto',
    },
  })
  const classes = useStylesToolTips()
  const handleTooltipClose = useCallback(() => {
    if (enableBackdropClick && onClose) {
      onClose()
    }
  }, [enableBackdropClick, onClose])
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      {/* need a div wrap the tooltip to not dismiss when click the content */}
      <div style={{ width: 'inherit' }}>
        <Tooltip arrow classes={classes} {...props} />
      </div>
    </ClickAwayListener>
  )
}
export default TooltipV2
